import { render } from "./EnrolleeStatusEditDependantOnboardComponent.vue?vue&type=template&id=56c0100c&scoped=true"
import script from "./EnrolleeStatusEditDependantOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeStatusEditDependantOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeStatusEditDependantOnboardComponent.vue?vue&type=style&index=0&id=56c0100c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c0100c"]])

export default __exports__